<template>
  <section class="tech-stack-section">
    <h1 class="title">
      <span class="light">TECH</span>
      <span class="dark">STACK</span>
    </h1>
    <div class="tech-cards">
      <TechStackCard
        logo="physics.png" 
        altText="React"
      />
      <TechStackCard
        logo="NextJS.png" 
        altText="NextJS"
      />      
      <TechStackCard
        logo="logo.png"
        altText="Vue"
      />
      <TechStackCard
        logo="node.png"
        altText="Node"
      />
      <TechStackCard
        logo="express.png"
        altText="Express"
      />
      <TechStackCard
        logo="mongo.png"
        altText="MongoDB"
      />

      <TechStackCard
        logo="figma.png"
        altText="Figma"
      />
      <TechStackCard
        logo="c-.png"
        altText="c++"
      />
        <TechStackCard
        logo="python.png"
        altText="python"
      />
    </div>
  </section>
</template>

<script>
import TechStackCard from '../components/TechStackCard.vue'

export default {
  name: 'TechStackSection',
  components: { TechStackCard }
}
</script>

<style scoped>
.tech-stack-section {
  background-color: #0f0d0d;
  padding: 40px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center; /* Center the section contents */
}

.title {
  font-size: 2.5rem;
  font-weight: 900;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column; /* Stack PREMIUM and TOOLS vertically */
  width: auto; /* Allow natural centering */
}

.light {
  color: white;
}

.dark {
  color: #3d3d3d;
}

.tech-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center; /* Center the rows */
  margin-top: 20px;
  max-width: 600px; /* Limit the container width */
}

.tech-cards > * {
  flex: 0 0 calc(33.33% - 13.33px);
  max-width: calc(33.33% - 13.33px);
  box-sizing: border-box;
}
</style>